import * as React from 'react';

export interface IPrivacyPolicyUIStateProps {
    dealerName?: string;
}

/* tslint:disable:max-line-length */
export const StandardPrivacyPolicyContentUI: React.ComponentType<IPrivacyPolicyUIStateProps> = (props: IPrivacyPolicyUIStateProps) => {
    return (
        <div>
        <div className="span12">
            <h1 id="top" className="dr-ui-legal-docs-headline">Privacy Statement </h1>
            <p>
                {props.dealerName} uses an experience on this website that is provided by one of our technology partners
                who provides the display of such items that may contain Payments, Credit Terms, Trade-In Values, and other
                tools that help provide a better shopping experience.  The use of this experience and the Privacy Policy
                is governed by their privacy policy below:
            </p>
            <hr />
            <h3 id="top">Autotrader Privacy Statement</h3>
            <p>Effective Date: March 16, 2015</p>
            <h4>Introduction</h4>
            <p>
                Thank you for your interest in Autotrader. We respect the privacy of our users when they use our
                websites, mobile and other online applications and products and services (collectively, the
                &quot;Autotrader Sites&quot;). By using Autotrader Sites, you consent to the use of your information
                and information about you in accordance with this Privacy Statement.
            </p>
            <p>
                When we refer to Autotrader within this Privacy Statement, we are referring to Autotrader, Inc. This
                Privacy Statement applies to information collected through the Autotrader Sites and does not describe
                the collection, use and disclosure practices of any of our corporate affiliates or third parties.
                For information on the collection, use and disclosure practices of any company with whom you are doing
                business, whether or not affiliated with Autotrader, please review their privacy policies.
            </p>
            <p>
                Services offered by Autotrader are not directed to individuals under the age of eighteen (18). If you
                are under eighteen (18), you should not provide any personal information to us.
            </p>
            <h5>This Privacy Statement covers: </h5>
            <ul>
                <li>
                    <a href="#1">Information We Collect</a>
                    <ul>
                        <li>
                            <a href="#2">Information You Provide</a>
                        </li>
                        <li>
                            <a href="#3">Automated Information</a>
                        </li>
                        <li>
                            <a href="#4">Data Technologies</a>
                        </li>
                        <li>
                            <a href="#5">Videos</a>
                        </li>
                        <li>
                            <a href="#6">Location Information</a>
                        </li>
                        <li>
                            <a href="#7">Publicly Posted Information</a>
                        </li>
                        <li>
                            <a href="#8">Combined Information and Information from Other Sources</a>
                        </li>
                    </ul>
                </li>
                <li>
                    <a href="#9">How We May Use the Information We Collect</a>
                </li>
                <li>
                    <a href="#10">Applications, Widgets and Social Media</a></li>
                <li>
                    <a href="#11">Advertising Networks</a></li>
                <li>
                    <a href="#12">Information We Share</a>
                    <ul>
                        <li>
                            <a href="#13">Affiliates</a>
                        </li>
                        <li>
                            <a href="#14">Our Service Providers</a>
                        </li>
                        <li>
                            <a href="#15">Co-Sponsored Promotions</a>
                        </li>
                        <li>
                            <a href="#16">Promotions on Behalf of Third Parties</a>
                        </li>
                        <li>
                            <a href="#17">Sellers, Dealers and Manufacturers</a>
                        </li>
                        <li>
                            <a href="#18">Credit Applications</a>
                        </li>
                        <li>
                            <a href="#19">Corporate and Asset Transactions</a>
                        </li>
                        <li>
                            <a href="#20">Other</a>
                        </li>
                    </ul>
                </li>
                <li>
                    <a href="#21">Your Choices</a></li>
                <li>
                    <a href="#22">Your California Privacy Rights</a></li>
                <li>
                    <a href="#23">Access and Correction</a></li>
                <li>
                    <a href="#24">Links</a></li>
                <li>
                    <a href="#25">Data Security</a></li>
                <li>
                    <a href="#26">Disputes</a></li>
                <li>
                    <a href="#27">Updates to this Privacy Statement</a></li>
                <li>
                    <a href="https://www.autotrader.com/legal/privacy-statement.xhtml#contact">How to Contact Us</a>
                </li>
            </ul>
            <hr />
            <h4 id="1">Information We Collect </h4>
            <p>
                Information is gathered from the Autotrader Sites by us, our service providers, advertisers, sponsors
                and partners.
            </p>
            <p id="2">
                Information You Provide. We may collect information that you choose to provide on the Autotrader Sites
                in a variety of ways, such as when you:
            </p>
            <ol>
                <li>
                    register for one of our products or services. This information may include your name, address,
                    telephone number, email address, Social Security Number, and credit information;
                </li>
                <li>make information available to us via social networking logins, such as Facebook or Twitter;</li>
                <li>
                    express an interest in buying, selling or trading in a car (such as by using our &quot;email the
                    seller&quot; function);
                </li>
                <li>participate in chats, web forums or other interactive sessions;</li>
                <li>apply for credit with a dealer or one of our finance partners;</li>
                <li>provide payment card information for one of our products or services;</li>
                <li>subscribe to newsletters or provide feedback; and</li>
                <li>participate in surveys, sweepstakes or other promotions.</li>
            </ol>
            <p id="3">
                Automated Information. Information regarding your use of the Autotrader Sites may be collected and/or
                aggregated through the use of automated means. This automatically collected information may include
                information such as:
            </p>
            <ol>
                <li>your IP address, the type of browser and operating system used;</li>
                <li>
                    date and time you access the Autotrader Site and pages you visit, and if you linked from or to
                    another website, the address of that website;
                </li>
                <li>email you open and links you click on within those email; and</li>
                <li>your ISP or mobile carrier, and the type of handheld or mobile device that you used.</li>
            </ol>
            <p id="4">
                Data Technologies. Various technologies are used to automatically collect information, such as cookies,
                local shared objects, and web beacons (generally referred to as &quot;Data Technologies&quot;.
                &quot;Cookies&quot; are small identifiers sent from a web server that are stored on your device for the
                purpose of identifying your browser or storing information or settings in your browser. &quot;Local
                shared objects,&quot; sometimes known as Flash cookies, may be used to store your preferences or display
                content based upon what you have viewed on various websites to personalize your visit. A &quot;web
                beacon,&quot; also known as an Internet tag, pixel tag or clear GIF, links web pages to web servers and
                their cookies. Anonymous advertising identifiers are increasingly being used on mobile devices and
                otherwise in a manner similar to cookies. When we refer to Data Technologies, we are including all
                current and similar future technologies.
            </p>
            <p>
                One or more Data Technologies may be used on the Autotrader Sites and other websites and mobile
                applications (that may not be the Autotrader Sites) by us, by another party on our behalf, or by third
                parties in accordance with their privacy policies. Data Technologies may be used by us and others, on
                our behalf and on their own behalf, to transmit information to you or about you and connect information
                about you from different sources, websites, devices, and mobile applications.
            </p>
            <p>
                We may use a uniquely generated trackable toll-free telephone number on dealer sites or in
                advertisements. If you call one of these uniquely generated toll-free numbers, we (or a service provider
                acting on our behalf) may collect non-personally identifiable information about the call (e.g. date,
                time, duration), as well as personally identifiable information (e.g. your name, the number from which
                your call originated).
            </p>
            <p id="5">
                Videos. We may target and track the videos you view on the Sites. You consent to our tracking of your
                video viewing through the Site or third party social media for up to two years or as permitted by
                applicable law.
            </p>
            <p id="6">
                Location Information. When you download or use ths Autotrader Sites, we may collect physical location
                information that is sufficiently precise to allow us to locate a specific person or device
                (&quot;Location Information&quot;). We also may collect Location Information when you visit or are in
                the vicinity of one of our dealers. We only collect Location Information with your permission (e.g.,
                such as when you agree to provide it to us after you initially access or download the Autotrader Sites).
                We may use Location Information and provide it to third parties to provide you with content and services
                that are relevant to a particular location, such as advertising, search results, dealers in the area,
                and direction, to evaluate and improve the Autotrader Sites, or to provide you with content and services
                relevant to one or more nearby dealers.
            </p>
            <p id="7">
                Publicly Posted Information. Information that you make available to us and others via social media
                networks, forums, blogs, list serves, chat rooms or similar functionality is public information that we
                or others may share or use in accordance with the law.
            </p>
            <p id="8">
                Combined Information and Information from Other Sources. We may combine information that you provide to
                us with information we receive from our affiliates and other sources, as well as with other information
                that is automatically collected. The combined information may include information about your use of the
                Sites, your use of other websites, devices and mobile applications and information from our affiliates
                and other sources.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="9">How We May Use the Information We Collect</h4>
            <p>We may use information we collect for the following purposes:</p>
            <ol>
                <li>
                    for everyday business purposes, such as establishing and managing your user account, providing
                    products and services you request, processing and collecting payments and providing customer
                    support;
                </li>
                <li>
                    to create listings and advertisements for any cars and other vehicles that you list for sale with
                    us. These lists and advertisements may appear on the Autotrader Sites and other websites, mobile
                    applications or services of third parties;
                </li>
                <li>to provide values and/or offers for cars that you would like to sell or trade in;</li>
                <li>to offer our other products or services and/or the products or services of others to you;</li>
                <li>
                    to communicate about, and administer your participation in, special events, programs, surveys,
                    contests, sweepstakes and other offers or promotions;
                </li>
                <li>
                    to enable you to interact with Autotrader and our users, dealers, manufacturers and others through
                    various means, such as through our message boards, blogs and social media;
                </li>
                <li>
                    to evaluate and improve our business, including developing new products and services and analyzing
                    the effectiveness of products, services, applications and websites;
                </li>
                <li>to diagnose and address technical and service problems;</li>
                <li>
                    to perform data analyses, including market and consumer research, trend analysis, demographic
                    analysis and financial analysis;
                </li>
                <li>
                    to deliver content (including advertising) correlating to your interests and browsing and usage
                    history, both within the Autotrader Sites and on other websites and applications;
                </li>
                <li>to comply with applicable legal requirements and our policies; and</li>
                <li>
                    to contact you via telephone, text or chat. We will obtain your consent to contact you when and
                    in the manner required by law.
                </li>
            </ol>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="10">Applications, Widgets and Social Media</h4>
            <p>
                We may include applications or widgets from social media providers that allow interaction or content
                sharing by their users. These widgets, such as a Facebook &quot;Share&quot; or &quot;Like&quot; button,
                are visible to you on the web page you visit. Integration between the Autotrader Sites and social media
                networks such as Facebook, Twitter and others may allow social media networks in which you participate
                to collect information about you, even when you do not explicitly activate the network&apos;s
                application or widget. Please visit the applicable social media network&apos;s privacy policy to better
                understand their data collection practices and choices they make available to you. The privacy policy
                of the social media network controls the collection, use and disclosure of all personal information
                transmitted to that network.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="11">Advertising Networks</h4>
            <p>
                Advertising that is customized based on predictions generated over time from your visits across
                different websites, devices and mobile applications is sometimes called &quot;online behavioral&quot;
                or &quot;interest-based&quot; advertising. We may partner with advertising networks, which are companies
                that deliver targeted advertisements to consumers and generate statistics and metrics related to the
                delivery of interest-based advertisements. They may utilize information collected through a variety of
                Data Technologies to provide customization, auditing, research and reporting for us, our affiliates
                and other advertisers. This data collection takes place both on the Autotrader Sites and on
                third-party&apos;s websites and mobile applications. This process allows Autotrader and third parties
                to deliver targeted advertising, enhance marketing programs and help track the effectiveness of such
                efforts. Our advertising networks also may use this information for determining or predicting the
                characteristics and preferences of their respective advertising audiences and measuring the
                effectiveness of their advertising in accordance with their privacy policies.
            </p>
            <p>
                We do not provide information that is directly associated with a specific person (such as name and
                address) to an advertising network when you interact with or view a customized advertisement. However,
                when you view or interact with an advertisement, the advertiser may make an assumption that you are
                interested in the subject matter of the advertisement.
            </p>
            <p>
                Some companies disclose when they are using interest-based advertising programs on the Autotrader Sites
                to deliver third-party ads or collecting information about your visit for these purposes and give you
                the ability to opt-out of this use of your information. You may see an icon
                <a href="http://www.aboutads.info/" target="_blank" rel="noopener noreferrer">
                    <img width="22" height="22" id="Picture 1" src="https://www.makemydeal.com/content/img/aboutads.jpg" alt="about ads" />
                </a>
                in or around third-party advertisements on the Autotrader Sites that use interest-based advertising
                programs and on pages where data is collected and used for online interest-based advertising. Clicking
                on this icon will provide additional information about the companies and data practices that were used
                to deliver the ad. You can opt out of delivery of targeted advertising to you by multiple companies by
                visiting
                <a href="http://www.aboutads.info/choices" target="_blank" rel="noopener noreferrer"> www.aboutads.info/choices</a>,
                <a href="http://www.networkadvertising.org/managing/opt_out.asp" target="_blank" rel="noopener noreferrer"> www.networkadvertising.org/managing/opt_out.asp </a>
                and
                <a href="http://www.evidon.com" target="_blank" rel="noopener noreferrer"> www.evidon.com</a>.  Please
                note that even if you opt out, you will continue to receive advertisements, but they will not be
                tailored to your specific interests.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="12">Information We Share</h4>
            <p>
                We do not sell or otherwise share information about you that we collect or receive, except as described
                below:
            </p>
            <ol>
                <li id="13">
                    Affiliates. We may share information about you, including personal information, with our corporate
                    affiliates, who will use it in accordance with their privacy policies. Please visit
                    <a href="http://www.coxautoinc.com/"> http://www.coxautoinc.com</a> for more information about our
                    affiliates.
                </li>
                <li id="14">
                    Our Service Providers. We may engage third parties to provide the services offered through or in
                    connection with the Autotrader Sites on our behalf. We require such providers to maintain
                    information about you as confidential and to use the information only to perform the services
                    specified by us in a manner consistent with this Privacy Statement.
                </li>
                <li id="15">
                    Co-Sponsored Promotions. In the event that you participate in a survey, sweepstakes, contest or
                    other promotion that is co-sponsored by Autotrader and a third party, we may share information
                    collected in conjunction with the survey, sweepstakes, contest or promotion, including personal
                    information, with that third party. After the information is provided to those third parties, the
                    subsequent use or disclosure of such information is subject to their privacy policies and practices.
                    Surveys, sweepstakes and other promotions conducted on behalf of Autotrader and a third party will
                    include branding from both Autotrader and the third party.
                </li>
                <li id="16">
                    Promotions on behalf of Third Parties. Periodically, third parties may conduct surveys, contests,
                    sweepstakes and other promotions for their own purpose on the Autotrader Sites. Information you
                    provide in response to those activities is governed by their privacy policies. Surveys, sweepstakes
                    and other promotions conducted solely for the purpose of a third party will include only the third
                    party&apos;s branding.
                </li>
                <li id="17">
                    Sellers, Dealers and Manufacturers. Information about you, including personal information and Data
                    Technologies, may be shared with sellers, dealers and manufacturers, and their agents and third
                    party service providers, who will use that information in accordance with their own privacy
                    policies. For example:
                </li>
                <ol>
                    <li>
                        If you are interested in a particular listing of a car for sale, information about you may be
                        shared with the seller of that particular car or similar cars or dealers in your area;
                    </li>
                    <li>
                        If you are considering trading in a car, we may provide information about you to dealers who
                        participate in our trade-in program and other dealers in your area;
                    </li>
                    <li>
                        We may provide manufacturers, their agents or third party service providers, with information
                        about you that we provided to their franchised dealers;
                    </li>
                    <li>We may provide manufacturers, their agents or third party service providers, with information
                        about you if you are interested in certified pre-owned vehicles; or
                    </li>
                    <li>
                        We may provide manufacturers, their agents or third party service providers, and dealers with
                        information about you when you access the Autotrader Sites via Autotrader branded advertising
                        and/or functionality found on their websites or other third party websites.
                    </li>
                </ol>
                <li id="18">
                    Credit Applications. If you apply for credit on the Autotrader Sites with us, our dealers, or any
                    third party, it will be necessary for you to provide personal information to complete the
                    application, including your address, credit information and history, employment and other financial
                    information. We may share your application information with the dealership(s) you selected and our
                    financial partners so that they can process your application and otherwise use it in accordance with
                    their privacy policies, however, we will not use your personal financial information for interest
                    based advertising.
                </li>
                <li id="19">
                    Corporate and Asset Transactions. If we sell all or substantially all of our business or sell or
                    transfer all or a material part of our assets, or are otherwise involved in a merger or transfer of
                    all or a substantial part of our business, we may transfer all information we have collected and
                    stored, including personal information, to the party or parties involved in the transaction as part
                    of that transaction.
                </li>
                <li id="20">
                    Other. We may access or disclose information, including personal information, to:
                    <ol>
                        <li>
                            protect or defend our interests and the legal rights or property of Autotrader and our
                            affiliates;
                        </li>
                        <li>
                            protect the rights, interests, safety and security of users of the Autotrader Sites or
                            members of the public;
                        </li>
                        <li>protect against fraud or for risk management purposes; or</li>
                        <li>
                            comply with prudent legal practice as we may determine, and applicable law or legal
                            process.
                        </li>
                    </ol>
                </li>
            </ol>

            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="21">Your Choices</h4>
            <p>
                You are entitled to make certain choices about how we communicate with you.
            </p>
            <ol>
                <li>
                    You may choose not to provide personal information, even though that might impact your ability to
                    register or receive a particular product or service.
                </li>
                <li>
                    If you do not want to receive marketing email from us, you can follow the unsubscribe link provided
                    in those emails.
                </li>
                <li>
                    If you do not want to receive interest-based advertisements, you can opt out as discussed in the
                    &quot;Advertising Networks&quot; section above.
                </li>
                <li>
                    You have a number of choices regarding certain Data Technologies. Most web browsers automatically
                    accept cookies, but you can usually modify your browser&apos;s setting to decline cookies if you
                    prefer. You may also render some web beacons unusable by rejecting their associated cookies and
                    disable or delete similar data used by browser add-ons, such as Flash cookies, by changing the
                    add-on&apos;s settings or opting out at Evidon.com or the website of the technology provider. If you
                    choose to decline cookies or similar technologies, however, please note that certain features may
                    not function properly or at all as a result. You may be able to adjust the use of advertising
                    identifiers on mobile devices through the settings on your device. Finally, if you do not want to
                    use a uniquely generated telephone number, you may choose to not call us.
                </li>
                <li>
                    If you do not want us to use Location Information, you can decline our initial invitation to provide
                    that information, or opt out by changing the location services settings on your mobile device.
                    However, please note that certain features may not function properly or at all as a result if you
                    opt out.
                </li>
            </ol>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="22">Your California Privacy Rights</h4>
            <p>
                California Civil Code Section 1798.83 entitles California users to request information concerning
                whether a business has disclosed certain information about you to any third parties for the third
                parties&apos; direct marketing purposes. California users who wish to request further information in
                compliance with this law or have questions or concerns about our privacy practices and policies may
                contact us as specified in the &quot;How to Contact Us&quot; section below.
            </p>
            <p>
                Online Tracking Policy for California Residents: As of the effective date of this Privacy Statement,
                there is no commonly accepted response for Do Not Track signals initiated by browsers, therefore we do
                not respond to them.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="23">Access and Correction</h4>
            <p>
                Access to information that we collect and maintain about you may be available to you. For example, if
                you created a password-protected account within the Autotrader Sites, you can access that account to
                update the information you previously provided. Additionally, if you believe that information we
                maintain about you is inaccurate, subject to applicable law, you may request that we correct or amend
                the information by contacting us as indicated in the &quot;How to Contact Us&quot; section below.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="24">Links</h4>
            <p>
                The Autotrader Sites may contain links to websites not operated by us, as well as third party widgets
                and applications discussed above. Once you leave the Autotrader Sites, we suggest that you review the
                applicable privacy policy of the third-party website or application. We are not responsible for the
                content or use of any websites or applications other than on the Autotrader Sites or the privacy
                practices of those websites or applications.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="25">Data Security</h4>
            <p>
                We use commercially reasonable administrative, technical, personnel, and physical security measures
                designed to safeguard information about you in our possession against loss, theft and unauthorized use,
                disclosure or modification. Of course, despite these measures, we cannot guarantee perfect security of
                networks, servers and databases we operate or that are operated on our behalf.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="26">Disputes</h4>
            <p>
                If you choose to visit the Autotrader Sites, your visit and any dispute regarding privacy is subject to
                this Privacy Statement and our Visitor Agreement, including limitations on damages, resolution of
                disputes, and application of the law of the state of Georgia.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="27">Updates to this Privacy Statement</h4>
            <p>
                We may update this Privacy Statement to provide clarification or notice of changes to our practices. If
                we make changes, we will revise the date at the top of this Privacy Statement. We will provide you with
                additional notice of material changes by posting notice of the changes for thirty (30) days before we
                implement those changes.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a><hr />
            <h4 id="28">How to Contact Us</h4>
            <p>
                If you have any questions or comments about this Privacy Statement, or if you would like us to update
                information we have about you or your preferences, please contact us by email at privacy@autotrader.com.
            </p>
            <a href="#top"><i className="icon-circle-arrow-up" />&nbsp;Back to top</a>
        </div>
    </div>
    );
};
